import { SET_PAGE_INFO } from '../actions/types';

const setPageInfo = (state = {}, action) => {
	if (!action.error && action.payload) {
		switch (action.type) {
			case SET_PAGE_INFO:
				return action.payload;

			// no default
		}
	}

	return state;
};

export default setPageInfo;
